export enum StartEndEnum {
  START,
  END,
}
